import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export function EditOutlined(props: IconProps = {}): JSX.Element {
  const { ...rest } = props;

  return (
    <SvgIcon name="EditOutlined" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8001 6.00001L18.0001 3.20001L15.1401 6.00001L18.0001 8.86001L20.8001 6.00001ZM16.5901 1.79001C16.9634 1.41442 17.4705 1.20224 18.0001 1.20001C18.5192 1.21008 19.0141 1.42166 19.3801 1.79001L22.2401 4.62001C22.6126 4.99474 22.8216 5.50164 22.8216 6.03001C22.8216 6.55838 22.6126 7.06529 22.2401 7.44001L18.0001 11.69L17.9825 11.6725L16.56 13.1L6.66 23H1V17.34L10.9 7.44L12.3275 6.0175L12.3101 6.00001L16.5901 1.79001ZM15.14 8.85999L13.73 7.44L12.31 8.85999L3 18.17V21H5.83L15.14 11.69L16.56 10.27L15.14 8.85999Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
